var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.baseClass},[_c('span',{staticClass:"eicon-"},[_vm._v("calendar")]),_c('EpbText',{attrs:{"type":"small","tag":"p"}},[_vm._v(_vm._s(_vm.dateRangeText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }